export class ContainerIterator {
    /**
     * @internal
     */
    constructor(iteratorType = 0 /* IteratorType.NORMAL */) {
        this.iteratorType = iteratorType;
    }
    /**
     * @param iter - The other iterator you want to compare.
     * @returns Whether this equals to obj.
     * @example
     * container.find(1).equals(container.end());
     */
    equals(iter) {
        return this._node === iter._node;
    }
}
export class Base {
    constructor() {
        /**
         * @description Container's size.
         * @internal
         */
        this._length = 0;
    }
    /**
     * @returns The size of the container.
     * @example
     * const container = new Vector([1, 2]);
     * console.log(container.length); // 2
     */
    get length() {
        return this._length;
    }
    /**
     * @returns The size of the container.
     * @example
     * const container = new Vector([1, 2]);
     * console.log(container.size()); // 2
     */
    size() {
        return this._length;
    }
    /**
     * @returns Whether the container is empty.
     * @example
     * container.clear();
     * console.log(container.empty());  // true
     */
    empty() {
        return this._length === 0;
    }
}
export class Container extends Base {
}
